import config from '../../config';

export default {
  url: `${config.api.baseURL}/subpage`,
  transformer(data) {
    return data;
  }
};
